import { j as c } from "../../../jsx-runtime-B6kdoens.js";
import { a as m } from "../../../index-CROKJrb5.js";
import { c as p, f } from "../../../create-component-CBAeEoQ6.js";
const u = p(
  "FooterDetails",
  f(
    ({ as: r, children: o, className: t, ...e }, a) => {
      const s = r || "div";
      return /* @__PURE__ */ c.jsx(
        s,
        {
          ref: a,
          className: m(
            "cur-flex cur-flex-wrap cur-gap-x-12 cur-gap-y-2",
            t
          ),
          ...e,
          children: o
        }
      );
    }
  )
);
export {
  u as FooterDetails
};
//# sourceMappingURL=index.js.map
